import { useAppSelector } from 'store/hooks'
import { selectAccountingTasks } from 'store/Accounting/accounting.selectors'
import { useAccountingContext } from 'containers/Accounting/AccountingContainer/AccountingContainer'
import SideModal from 'components/Shared/SideModal/SideModal'
import './styles.scss'

const AccountingTasksDrawer = () => {
  const {
    isAccountingTasksDrawerOpen,
    toggleAccountingTasksDrawerHandler,
    toggleAccountingTaskStatusHandler,
  } = useAccountingContext()

  const accountingTasks = useAppSelector(selectAccountingTasks)

  return (
    <SideModal
      className="accounting-tasks-drawer"
      isOpen={isAccountingTasksDrawerOpen}
      onClose={toggleAccountingTasksDrawerHandler}>
      {accountingTasks ? (
        <ul>
          {accountingTasks.map(item => (
            <div key={`${item.idTask}1`}>
              <li key={item.idTask}>
                <input
                  type="checkbox"
                  checked={item.checked}
                  onChange={() => toggleAccountingTaskStatusHandler(item.idTask)}
                />
                <label>{item.task}</label>
              </li>
              {item.checked && item.completedAt ? (
                <small key={`1${item.idTask}`} className="placeHolderText">
                  {item.completedAt}
                </small>
              ) : (
                item.checked &&
                !item.completedAt && (
                  <small className="placeHolderText">Cargando...</small>
                )
              )}
            </div>
          ))}
        </ul>
      ) : (
        <p className="noData">No hay tareas disponibles</p>
      )}
    </SideModal>
  )
}

export default AccountingTasksDrawer
